import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'

export default function EditNumberCell({
  id,
  rowData,
  dataKey,
  register,
  control,
  errors,
  isRequired = true,
  isEdit,
  isBudgetFormat = false,
  styleSheet,
  onChangeCell = () => {},
  disabled = false,
  allowNegative = true,
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  let value = rowData[dataKey]
    ? isBudgetFormat
      ? budgetFormat(rowData[dataKey])
      : rowData[dataKey].toLocaleString()
    : isBudgetFormat
      ? '0.00'
      : '0'

  const _id = id || rowData.id

  return (
    <span {...props} className={editing ? 'table-content-editing' : ''}>
      {/* {editing && rowData[dataKey] !== undefined ? ( */}
      {editing ? (
        <Controller
          name={_id}
          control={control}
          defaultValue={rowData[dataKey] || 0}
          rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
          render={(props) => {
            return (
              <NumberFormat
                //id={`${dataKey}_${rowData.id}`}
                style={styleSheet}
                className={classNames('rs-input', errors[_id] && 'is-error')}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale
                value={props.value}
                onValueChange={(value) => {
                  props.onChange(value.floatValue)
                  onChangeCell(value.floatValue, _id)
                }}
                disabled={disabled}
                allowNegative={allowNegative}
              />
            )
          }}
        />
      ) : (
        <span>{value}</span>
      )}
    </span>
  )
}
